export enum RequirementNames {
  ABLE_TO_USE_MEDICATION = 'ABLE_TO_USE_MEDICATION',
  ABLE_TO_USE_TRACKER = 'ABLE_TO_USE_TRACKER',
  ABLE_TO_VIEW_BOTTOM_BAR = 'ABLE_TO_VIEW_BOTTOM_BAR'
}
